<template>
    <div class="herd-card">
        <h5>{{ system.name }}</h5>
        <sci-chart-herd-weight style="position: relative;" :sid="system.id" :systemId="system.id"/>
    </div>
</template>

<script>
import SciChartHerdWeight from '../Charts/SciChartHerdWeight.vue'

export default {
    components: { SciChartHerdWeight },
    props: {
        system: {
        }
    }
}
</script>

<style scoped>
.herd-card {
    color: white;
    padding: 5px 10px;
    margin: 5px 10px;
    background: #414F51;
    border: 1px solid #30383a;
    border-radius: 5px;
    transition-duration: 0.5s;
}
</style>


// WEBPACK FOOTER //
// src/components/Systems/SystemHerdWeightCard.vue